const cave_lizard = (level) => {
  const handle = 'cave_lizard';
  const types = ['beast', 'lizard', 'reptile'];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'cave_lizard_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          quickness: {
            handle: 'quickness',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          armor_spikes: {
            handle: 'armor_spikes',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
      perception: Math.round(3 + bound_level * 0.55 + Math.random() * 3),
      mana: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
      toughness: Math.round(3 + bound_level * 0.6 + Math.random() * 3),
      strength: Math.round(3 + bound_level * 0.55 + Math.random() * 3),
      willpower: Math.round(2 + bound_level * 0.3 + Math.random() * 3),
      dexterity: Math.round(4 + bound_level * 0.7 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'],
    getStarterEquipment: () => ({}),
    xpValue: level * 130,
    drops_gold: false,
    drops_equipment: false,
    bags: [],
    build: {
      ai: {
        priorities: ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'],
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: {},
      equipped_abilities: [{ value: 'move' }, { value: 'melee_attack' }],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = cave_lizard;
